import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Paper, Typography } from "@mui/material";
import "./CookieConsent.css";
import CookieIcon from "@mui/icons-material/Cookie";

const GA_ID = "G-D7PNHZQGRN";
const STORAGE_KEY = "bws-cookie-consent"; // "accepted" | "rejected"

function loadGoogleAnalytics() {
  if (window.__gaLoaded) return;
  window.__gaLoaded = true;

  // Load gtag.js
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  // Init gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

export default function CookieConsent() {
  const [choice, setChoice] = React.useState(() => localStorage.getItem(STORAGE_KEY));

  React.useEffect(() => {
    if (choice === "accepted") loadGoogleAnalytics();
  }, [choice]);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setChoice("accepted");
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    setChoice("rejected");
  };

  // If already chosen, don't show banner
  if (choice === "accepted" || choice === "rejected") return null;

  return (
    <div className="bws-cookieWrap" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <Paper className="bws-cookieCard" elevation={0}>
        <div className="bws-cookieText">
          <div className="bws-cookieHeader">
            <CookieIcon className="bws-cookieIcon" />
            <Typography className="bws-cookieTitle">Cookies</Typography>
</div>

          <Typography className="bws-cookieBody">
            We use cookies to monitor website performance and to improve the user experience.
          </Typography>
          <Typography className="bws-cookieLinks">
            <RouterLink className="bws-privacyLink" to="/privacy">
              Privacy Policy
            </RouterLink>
          </Typography>
        </div>

        <div className="
        bws-cookieActions">
          <Button variant="contained" onClick={accept} sx={{minWidth:'80px'}}>
            Accept
          </Button>
          <Button variant="contained" onClick={reject} sx={{minWidth:'80px'}}>
            Reject
          </Button>
        </div>
      </Paper>
    </div>
  );
}